interface Data {
  borderColor?: string | null;
  borderWidth?: number | null;
}

export const hasBorder = (data: Data): boolean => {
  const { borderColor, borderWidth } = data;
  return !!(
    borderColor &&
    borderColor !== "none" &&
    borderColor !== "transparent" &&
    (borderWidth ?? 0) > 0
  );
};
